<vi-page [sidenavs]="true" [footer]="true">
  <app-commercial-toolbar *appForCommercialUser="true" head></app-commercial-toolbar>
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar *ngIf="!(authStore.isCommercialUser$ | async)" head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="updates"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="updates"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.UPDATES' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>
  <vi-header [shadow]="false" head color="white">
    <div data-at-bar-message class="header flex flex-col gap-[12px] flex-auto">
      <h1 data-at-title-updates>
        {{ '+UPDATES.TITLE' | translate }}
      </h1>
    </div>
  </vi-header>

  <vi-content body>
    <ng-container main *ngIf="updatesStore.loading$ | async; else loader">
      <app-updates-tabs
        *ngIf="updatesStore.updatesAmount$ | async as updatesAmount"
        [viGuideUpdatesAmount]="updatesAmount.viGuideUpdatesAmount"
        [viCareAndroidUpdatesAmount]="updatesAmount.viCareAndroidUpdatesAmount"
        [viCareIOSUpdatesAmount]="updatesAmount.viCareIOSUpdatesAmount"
        (tabChanged)="onTabChanged($event)"
      ></app-updates-tabs>

      <div class="divider"></div>

      <div class="flex flex-col">
        <ng-container [ngSwitch]="activeTab">
          <ng-container *ngSwitchCase="changeLogTypeEnum.ViGuide">
            <ng-container *ngIf="updatesStore.viGuideUpdates$ | async as updates">
              <app-viguide-update
                data-at-update
                *ngFor="let update of updates"
                [update]="update"
              ></app-viguide-update>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="changeLogTypeEnum.ViCareAndroid">
            <ng-container *ngIf="updatesStore.viCareAndroidUpdates$ | async as updates">
              <app-vicare-update
                data-at-update
                *ngFor="let update of updates"
                [update]="update"
              ></app-vicare-update>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="changeLogTypeEnum.ViCareIOS">
            <ng-container *ngIf="updatesStore.viCareIOSUpdates$ | async as updates">
              <app-vicare-update
                data-at-update
                *ngFor="let update of updates"
                [update]="update"
              ></app-vicare-update>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #loader>
      <vi-loader
        main
        data-at-loader
        [isLoading]="true"
        message="{{ '+UPDATES.LOADING_MESSAGE' | translate }}"
      ></vi-loader>
    </ng-template>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
